export class PublicationCategoryEntity {
  id: number;
  name_En: string;
  name_Fr: string;
  groupName_En: string;
  groupName_Fr: string;

  constructor(entity?: PublicationCategoryEntity) {
    if (entity) {
      Object.assign(this, { ...entity });
    } else {
      this.id = 0;
      this.name_En = '';
      this.name_Fr = '';
      this.groupName_En = '';
      this.groupName_Fr = '';
    }
  }
}
